import z, { ZodEnum, ZodType } from 'zod';
import type { util } from 'zod/v4/core';

export type OtherString = string & {};

export type DeepPartial<T> = 0 extends 1 & T ? T : T extends object ? { [K in keyof T]?: DeepPartial<T[K]> } : T;

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};

export function ndefault<T>(type: ZodType<T>, defaultValue: NonNullable<T>): ZodType<NonNullable<T>> {
  return type.nullish().transform((value) => value ?? defaultValue);
}

export function loose<T extends util.EnumLike>(type: ZodEnum<T>): ZodType<T[keyof T] | OtherString> {
  return type.or(z.string());
}
